import React from 'react';
import { Trans } from '@lingui/react';

export default {
    'Manage students': <Trans>Manage students</Trans>,
    Classes: <Trans>Classes</Trans>,
    'WHOLE CLASS': <Trans>WHOLE CLASS</Trans>,
    Unassign: <Trans>Unasssign</Trans>,
    NoClasses: <Trans>No classes created</Trans>,
    admin: <Trans>Please contact your school administration</Trans>
};



// WEBPACK FOOTER //
// ./containers/whole-class/whole-class-text.js